import { render, staticRenderFns } from "./EmailTemplatesPage.vue?vue&type=template&id=3dd67d7c&scoped=true"
import script from "./EmailTemplatesPage.vue?vue&type=script&lang=js"
export * from "./EmailTemplatesPage.vue?vue&type=script&lang=js"
import style0 from "./EmailTemplatesPage.vue?vue&type=style&index=0&id=3dd67d7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd67d7c",
  null
  
)

export default component.exports